/* eslint-disable no-undef */
import { getUserInfo, isActiveSubscribedUser, isIapOperator } from '../../utils/user';
import { ExpirationBanner } from '@intigral/shared';
import { __ } from '../../translations';
import user from '../../helpers/user';
import { isUserInGracePeriod } from '@intigral/utils';
import { useSelector } from 'react-redux';
import { IStore } from '../../interfaces/StoreTypes';
import { useConfigurationSections } from '../../hooks/useConfiguration';

export const UserStatus = () => {
    const userInfo = getUserInfo();
    const userStatus = isActiveSubscribedUser(userInfo);
    const isGracePeriod = isUserInGracePeriod();
    const isKidsMode = useSelector((state: IStore) => Boolean(state.profile?.selectedProfile?.kidsMode));
    const { iap_operators } = useConfigurationSections();
    const isIapUser = isIapOperator(userInfo?.operator, iap_operators);
    if (userStatus && !isGracePeriod) {
        return null;
    }

    const accountLabel = __('user_inactive_banner_part_two');

    return (
        <ExpirationBanner>
            {isIapUser ? (
                <p className="settings-warning-desc">{__('payment_failure_status_desc_iap')}</p>
            ) : (
                <p>
                    {__('user_inactive_banner_part_one')}{' '}
                    {isKidsMode ? accountLabel : <a href={user?.getMyAccountUrl?.() ?? '#'}>{accountLabel}</a>}{' '}
                    {__('user_inactive_banner_part_three')}
                </p>
            )}
        </ExpirationBanner>
    );
};
